import { useEffect } from 'react';

export const usePageTitle = (title: string, suffix: string = 'Get To Know Me') => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} - ${suffix}` : suffix;
    
    return () => {
      document.title = previousTitle;
    };
  }, [title, suffix]);
};